import React, { Component } from 'react';
import { compose } from 'react-apollo';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { withAppContext } from '../contexts/app';
import { withUser } from '../contexts/user';

import ImageUploader from '../components/ImageUploader';
import HamburgerButton from './HamburgerButton';
import HamburgerMenu from './HamburgerMenu';
import UserSignInLink from '../components/UserSignInLink';
import UserSignOutLink from '../components/UserSignOutLink';
import UserDropdown from '../components/UserDropdown';
import UserAvatar from '../components/UserAvatar';
import { MobileTabletOnly } from 'shared/Responsive';
import { wasOnlyModalOpenOrClosed } from 'shared/Modal';

import LogoOnWhite from 'images/ask/logo-text-dark.svg';
import LogoOnDark from 'images/ask/logo-text-white.svg';

const DARK_NAVBAR_FOR = [];
const PAMPAS_NAVBAR_FOR = ['/', '/about', '/health', '/results', '/results-view'];
const POLAR_NAVBAR_FOR = ['/clinical'];

const copy = {
  startScan: 'Start your scan',
  about: 'About',
  healthAZ: 'Skin Health A-Z',
  clinicalSolutions: 'Clinical Solutions'
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuIsOpen: false
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!wasOnlyModalOpenOrClosed(newProps.location, this.props.location)) {
      this.closeMenu();
    }
  }

  handleHamburgerClick = () => {
    if (this.state.menuIsOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    disableBodyScroll(this.navbarElement);
    this.setState({ menuIsOpen: true });
  }

  closeMenu() {
    enableBodyScroll(this.navbarElement);
    this.setState({ menuIsOpen: false });
  }

  render() {
    const { menuIsOpen } = this.state;
    const { currentUser } = this.props.user;
    const { isOfflineMode } = this.props.app;

    const isDark = DARK_NAVBAR_FOR.includes(this.props.location.pathname);
    const isPampas = PAMPAS_NAVBAR_FOR.includes(this.props.location.pathname);
    const isPolar = POLAR_NAVBAR_FOR.includes(this.props.location.pathname);
    const logo = isDark ? LogoOnDark : LogoOnWhite;
    const hamburgerTheme = isDark ? 'light' : 'dark';

    return (
      <div ref={e => this.navbarElement = e} className={cx('navbar', {
        'navbar--fixed': menuIsOpen,
        'navbar--dark': isDark,
        'navbar--pampas': isPampas,
        'navbar--polar': isPolar
      })}>
        <div className="navbar__content">
          <div className="container">
            <div className="navbar__left">
              <div className="logo">
                <Link to="/"><img src={logo} className="logo" /></Link>
              </div>
            </div>

            {!isOfflineMode && (
              <div className="navbar__center">
                <div className="navbar__group">
                  <Link to="/about">{ copy.about }</Link>
                  <Link to="/health">{ copy.healthAZ }</Link>
                  <Link to="/clinical">{ copy.clinicalSolutions }</Link>
                </div>
              </div>
            )}

            <div className="navbar__right">
              <div className="navbar__group">
                {!isOfflineMode && (
                  <React.Fragment>
                    <Link to="/about" className="about-link navbar__right__link">{ copy.about }</Link>
                    {!currentUser && <UserSignInLink />}
                  </React.Fragment>
                )}

                {/* We're using the image uploader below instead
                    <Link to="/get-started" className="get-started-link">
                    <span className="button button--small button--gradient">{ copy.startScan }</span>
                    </Link>
                  */}

                <ImageUploader
                  className="button button--small button--gradient get-started-link"
                  label={copy.startScan}
                  onUpload={this.onImageUpload.bind(this)}
                />

                <HamburgerButton onClick={this.handleHamburgerClick} isActive={menuIsOpen} theme={hamburgerTheme} />

                {!isOfflineMode && currentUser && <UserDropdown />}
              </div>
            </div>
          </div>
        </div>

        <MobileTabletOnly>
          <HamburgerMenu isOpen={menuIsOpen}>
            {!isOfflineMode && (
              <div className="links">
                {currentUser ? (
                  <React.Fragment>
                    <Link to="/profile" className="profile-link">
                      Profile
                      <UserAvatar />
                    </Link>
                    <UserSignOutLink />
                  </React.Fragment>
                ) : (
                  <UserSignInLink />
                )}
              </div>
            )}

            <div className="links">
              {!isOfflineMode && (
                <React.Fragment>
                  <Link to="/about" className="about-link">{ copy.about }</Link>
                  <Link to="/health">{ copy.healthAZ }</Link>
                  <Link to="/clinical">{ copy.clinicalSolutions }</Link>
                </React.Fragment>
              )}

              {/* We're using the image uploader below instead
                  <Link to="/get-started">
                  <span className="button button--medium button--gradient">{ copy.startScan }</span>
                  </Link>
                */}

              <ImageUploader
                className="button button--medium button--gradient get-started-link get-started-link--mobile"
                label={copy.startScan}
                onUpload={this.onImageUpload.bind(this)}
              />
            </div>
          </HamburgerMenu>
        </MobileTabletOnly>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

Header.defaultProps = {};

Header.propTypes = {
  app: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default compose(
  withAppContext,
  withUser,
  withRouter
)(Header);
